// removed by extract-text-webpack-plugin
module.exports = {"product-detail-slider":"product-detail-slider","product-detail-item":"product-detail-item","slick-next":"slick-next","slick-prev":"slick-prev","slick-arrow":"slick-arrow","slick-thumb":"slick-thumb"};


//////////////////
// WEBPACK FOOTER
// ./components/product-detail/sub-view/list-product-detail-image/style.scss
// module id = ./components/product-detail/sub-view/list-product-detail-image/style.scss
// module chunks = 0